module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAMRJREFUSEu11UEOgkAMBdDWFQncybjCK8hlxMuAR5Cd3mlM3JgqLBQSZ6b9Ffb8N+lM85lW/njlfEoCcqi2xFJwdx/Qg0QBacqamC9TsFDLXTghSBwYT7+h6ycURNIjaqrje4itB8lesjiRLDBdgQNRAR5EDaCICUAQM/ATedKOz+H7pGcL8x9AZB/bdjNgfVEmwBo+TkoNIOFqAA1XAZ7wLOANTwKLPnB0gq4PwC5QjKisSfjBfbghbZYF0ND5f+o9QLEXL454GWdp6XUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionBank/img(5).png
// module id = iFnR
// module chunks = 1